import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const TeamFormDialog = ({ open, onOpenChange, title, config, initial, lockSport, submitLabel, onSubmit, testPrefix }) => {
  const [form, setForm] = useState(initial);
  const [busy, setBusy] = useState(false);
  const levels = Object.entries(config.sports[form.sport]);
  const set = (patch) => setForm((f) => ({ ...f, ...patch }));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await onSubmit(form); onOpenChange(false); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid={`${testPrefix}-dialog`}>
        <DialogHeader><DialogTitle className="font-heading text-2xl uppercase">{title}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid={`${testPrefix}-name-input`} className="field-input w-full" placeholder="Team name, e.g. Tigers 10U" required maxLength={60}
            value={form.name} onChange={(e) => set({ name: e.target.value })} />
          <input data-testid={`${testPrefix}-season-input`} className="field-input w-full" placeholder="Season (optional), e.g. Spring 2026" maxLength={40}
            value={form.season || ""} onChange={(e) => set({ season: e.target.value })} />
          {!lockSport && (
            <select data-testid={`${testPrefix}-sport-select`} className="field-input w-full" value={form.sport}
              onChange={(e) => set({ sport: e.target.value, level: Object.keys(config.sports[e.target.value])[0] })}>
              <option value="baseball">Baseball</option>
              <option value="softball">Softball</option>
            </select>
          )}
          <select data-testid={`${testPrefix}-level-select`} className="field-input w-full" value={form.level} onChange={(e) => set({ level: e.target.value })}>
            {levels.map(([id, l]) => <option key={id} value={id}>{l.name}</option>)}
          </select>
          <button data-testid={`${testPrefix}-submit-button`} className="btn-primary w-full" disabled={busy}>{submitLabel}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
